/* eslint-disable no-unused-vars */
import React, { useStore, useMemo, useState, useEffect } from 'react';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Box, Tab, Tabs } from '@mui/material';
import { toast } from 'react-toastify';
import _ from 'lodash';
import moment from 'moment';
import TabPanel from '../../components/TabPanel';
import { DashboardProvider } from '../Dashboard/useDashboard';
import Filter from './components/Filter';
import Table from './components/Table';
import { postSalesWeeklyReport, postSalesWeeklyReportExport } from '../../api/salesReportApi';
import useSalesWeeklyReportContext from './context/useSalesWeeklyReportContext';

export default function SalesWeeklyReport() {
  const defaultFilter = {
    department: { label: 'ALL', value: null },
    team: { label: 'ALL', value: null },
    head_id: { label: 'ALL', value: null },
    manager_id: { label: 'ALL', value: null },
    rep_id: { label: 'ALL', value: null },
    agenda: [{ label: 'ALL', value: null }],
    specialty: [{ label: 'ALL', value: null }],
    from: moment().startOf('month').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
  };

  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [salesReport, setSalesReport] = useState([]);
  const [filterForm, setFilterForm] = useState(defaultFilter);

  const handleChangeActiveTab = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleGenerateReport = async () => {
    try {
      setLoading(true);
      const request = {
        department: filterForm?.department?.value,
        team: [filterForm?.team?.value],
        head_id: filterForm?.head_id?.value,
        manager_id: filterForm?.manager_id?.value,
        rep_id: filterForm?.rep_id?.value,
        agenda:
          filterForm?.agenda[0].value !== null ? filterForm?.agenda?.map((row) => row.value) : [],
        specialty:
          filterForm?.specialty[0].value !== null
            ? filterForm?.specialty?.map((row) => row.value)
            : [],
        from: filterForm?.from,
        to: filterForm?.to,
      };
      //
      const response = await postSalesWeeklyReport(request);
      const { code, data } = response.data;
      if (code === '200') {
        setSalesReport(data);
      }
      setLoading(false);
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleReportExport = async () => {
    try {
      toast.loading('Please wait ...');
      const request = {
        department: filterForm?.department?.value,
        team: [filterForm?.team?.value],
        head_id: filterForm?.head_id?.value,
        manager_id: filterForm?.manager_id?.value,
        rep_id: filterForm?.rep_id?.value,
        agenda:
          filterForm?.agenda[0].value !== null ? filterForm?.agenda?.map((row) => row.value) : [],
        specialty:
          filterForm?.specialty[0].value !== null
            ? filterForm?.specialty?.map((row) => row.value)
            : [],
        from: filterForm?.from,
        to: filterForm?.to,
      };

      const res = await postSalesWeeklyReportExport(request);

      const { code, result, message } = res.data.response;
      if (code !== '200') {
        throw Object.assign(new Error(message), { code: 402 });
      }
      toast.dismiss();

      if (code === '200') {
        toast.success(`file has been successfully exported: ${res.data.response.file_name}`);
        window.location.href = result;
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  const handleClearReport = () => {
    setFilterForm(defaultFilter);
    handleGenerateReport();
  };

  useEffect(() => {
    handleGenerateReport();
  }, []);
  return (
    <DashboardProvider>
      <useSalesWeeklyReportContext.Provider
        value={useMemo(
          () => ({
            loading,
            salesReport,
            filterForm,
            setFilterForm,
            handleGenerateReport,
            handleClearReport,
            handleReportExport,
          }),
          [loading, salesReport, filterForm],
        )}
      >
        <Box sx={{ backgroundColor: '#fff', p: 1, boxShadow: 3 }}>
          <Filter />
        </Box>

        <Box padding={4}>
          <Grid container spacing={2}>
            <Grid xs={12} sm={12} md={12}>
              <Box sx={{ backgroundColor: '#fff' }} mt={4}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={activeTab}
                    onChange={handleChangeActiveTab}
                    aria-label='basic tabs example'
                  >
                    <Tab
                      label='Sales - Weekly Report'
                      id='weekly-sales-report'
                      aria-controls='weekly-sales-report'
                    />
                  </Tabs>
                </Box>
                <TabPanel value={activeTab} index={activeTab}>
                  <Table />
                </TabPanel>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </useSalesWeeklyReportContext.Provider>
    </DashboardProvider>
  );
}
